import { useTranslation } from "react-i18next";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { DRUCKPFAHL, ZUGPFAHL } from "../../../../constants.js";

function LoadDirection({ value }) {
  const { t } = useTranslation("translation");

  function renderBelastungsartUndRichtung(val) {
    switch (val) {
      case DRUCKPFAHL:
        return t("inner.compressionPile");
      case ZUGPFAHL:
        return t("inner.tensionPile");
      default:
        return "";
    }
  }

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionMicropiles.loadDirection")}</p>}
      inputValue={<span className="input">{renderBelastungsartUndRichtung(value)}</span>}
    />
  );
}

export default LoadDirection;
